import React, { useEffect, useMemo, useRef, useState } from "react";
import DialogWrap, { DialogWrapLogin, DialogWrapMedium } from "../../../controls/components/dialogWrap/DialogWrap";
import { ActiveType } from "../../../../models/Login";
import {
	FomrmLoginInput,
	FomrmLoginInputPhone,
	FomrmLoginInputPhoneNumberInner,
	SeledctApp,
} from "../../LoginUser/styled/LoginStyles";
import { getCountryRates } from "../../../../services/CountryRatesService";
import {
	OrderInput,
	OrderInputPhoneNumberWrap,
	OrderInputWrap,
	OrderPageInfomationTime,
	OrderPageInfomationTimeTitle,
	OrderPageInfomationTimeWrap,
} from "../../Order/styled/OrderStyle";
import DateRangeInput, { TimeRangeInput } from "../../../controls/components/dateRangeInput/DateRangeInputOrder";
import { CustomDropdown, SelectApp } from "../../LoginUser/component/FormCreateOne";
import { PHONE_COUNTRY_CODE } from "../../LoginUser/hook/phoneCountryCode";
import {
	InputOrderAdminTitle,
	UserFormServiceButtonClose,
	UserFormServiceButtonCreated,
} from "../../MyBooking/styled/DesStyled";
import useAddPartnerAdmin from "../hook/AddPartnerAdmin";
import { SmSelectAsyncSearchBox } from "../../../controls/components/selectAsyncSearchBox/SelectAsyncSearchBox";
import { getListPartnerEmail } from "../../../../services/PartnerService";
import { SelectAsyncOptionType } from "react-select/async";
import { AdminFilterEmailPartner } from "../hook/FilterEmailPartner";
import PartnerDestinationSelect, { PartnerDestinationSelectHandle } from "./PartnerDestinationSelect";
import styled from "styled-components";
import { buildPartnerPricingPreview } from "./partnerPricingPreview";

const CheckboxContainer = styled.div`
	margin-bottom: 15px;
	display: flex;
	align-items: center;
`;

const CheckboxInput = styled.input`
	margin-right: 10px;
	cursor: pointer;
`;

const CheckboxLabel = styled.span`
	font-size: 14px;
	color: var(--text-color0);
	cursor: pointer;
`;

// Component để load và chọn partner với email và ID
function PartnerSelectWithEmail(props: {
	selectedPartnerId: string;
	setSelectedPartnerEmail: (val: string) => void;
	setSelectedPartnerId: (val: string) => void;
}) {
	const [partnerOptions, setPartnerOptions] = useState<any[]>([]);

	const loadPartnerList = async (input: string, setOpts: (val: SelectAsyncOptionType[]) => void) => {
		try {
			const data = await getListPartnerEmail(input, false);
			const res = data;
			if (res) {
				const selectOpts = res.map((item: any) => ({
					value: item.id,
					label: `${item.email} (${item.fullName})`,
					email: item.email,
					id: item.id,
				}));
				const filteredOptions = selectOpts.filter((option: any) =>
					option.label.toLowerCase().includes(input.toLowerCase())
				);
				const clearOption = { label: "All", value: "", email: "", id: "" };
				const finalOptions = [clearOption, ...filteredOptions];
				setOpts?.(finalOptions);
				setPartnerOptions(finalOptions);
				return finalOptions;
			}
		} catch (err) {
			console.error(err);
		}

		setOpts([]);
		return;
	};

	const handlePartnerChange = (value: any, item: any) => {
		if (item && item.value !== "") {
			props.setSelectedPartnerEmail(item.email);
			props.setSelectedPartnerId(item.id);
		} else {
			props.setSelectedPartnerEmail("");
			props.setSelectedPartnerId("");
		}
	};

	return (
		<SmSelectAsyncSearchBox
			selectedId={props.selectedPartnerId}
			onChange={handlePartnerChange}
			loadOptionPromise={loadPartnerList}
		/>
	);
}

export default function DialogAddPartnerAdmin(props: {
	openDialog: boolean;
	setOpenDialog: (value: boolean) => void;
	reload: () => void;
}) {
	const [email, setEmail] = useState("");
	const [pass, setPass] = useState("");
	const [name, setName] = useState("");
	const [phone, setPhone] = useState("");
	const [selectedCountryCode, setSelectedCountryCode] = useState(PHONE_COUNTRY_CODE[0].dial_code);
	const [address, setAddress] = useState("");
	const [addressText, setAddressText] = useState("");
	const [note, setNote] = useState("");
	const [rateReview, setRateReview] = useState("");
	const [reviewCount, setReviewCount] = useState("");
	const [displayName, setDisplayName] = useState("");
	const [displayAddress, setDisplayAddress] = useState("");
	const [selectedPartnerEmail, setSelectedPartnerEmail] = useState("");
	const [selectedPartnerId, setSelectedPartnerId] = useState("");
	const [isAddToExistingPartner, setIsAddToExistingPartner] = useState(false);
	const [stationCom, setStationCom] = useState("");
	const [minimumPayout, setMinimumPayout] = useState("");
	const [pubRate, setPubRate] = useState("");
	const [countryRatesRows, setCountryRatesRows] = useState<any[]>([]);
	const [lat, setLat] = useState("");
	const [long, setLong] = useState("");
	const [locationId, setLocationId] = useState("");
	const [selectedLocation, setSelectedLocation] = useState<any | null>(null);

	useEffect(() => {
		if (props.openDialog) {
			getCountryRates()
				.then((data) => setCountryRatesRows(data?.rows || []))
				.catch(() => setCountryRatesRows([]));
		}
	}, [props.openDialog]);

	const { addPartnerAd } = useAddPartnerAdmin({ reload: props.reload });
	const destinationSelectRef = useRef<PartnerDestinationSelectHandle | null>(null);

	const handleSave = async () => {
		const finalEmailPartner = isAddToExistingPartner ? selectedPartnerEmail : email;
		const finalPartnerId = isAddToExistingPartner ? selectedPartnerId : "";

		let finalLocationId = locationId;
		try {
			const ensured = await destinationSelectRef.current?.ensureMissingDestination?.();
			if (typeof ensured === "string" && ensured.length > 0) {
				finalLocationId = ensured;
			}
		} catch (e) {
			console.error(e);
		}

		await addPartnerAd(
			name,
			finalEmailPartner,
			phone,
			pass,
			address,
			addressText,
			note,
			selectedCountryCode,
			rateReview,
			reviewCount,
			displayName,
			displayAddress,
			finalPartnerId,
			isAddToExistingPartner ? true : false,
			stationCom ? parseFloat(stationCom) : undefined,
			minimumPayout ? parseFloat(minimumPayout) : undefined,
			pubRate ? parseFloat(pubRate) : undefined,
			lat,
			long,
			finalLocationId
		);
		props.setOpenDialog(false);
	};
	return (
		<DialogWrapMedium
			login={true}
			open={props.openDialog}
			onClose={() => {
				props.setOpenDialog(false);
			}}
			title="Add Station"
			actions={
				<>
					<UserFormServiceButtonClose onClick={() => props.setOpenDialog(false)}>
						Cancel
					</UserFormServiceButtonClose>
					<UserFormServiceButtonCreated onClick={handleSave}>Save</UserFormServiceButtonCreated>
				</>
			}>
			<InputPartnerAdmin
				name={name}
				setName={setName}
				email={email}
				setEmail={setEmail}
				phone={phone}
				setPhone={setPhone}
				pass={pass}
				setPass={setPass}
				selectedCountryCode={selectedCountryCode}
				setSelectedCountryCode={setSelectedCountryCode}
				address={address}
				setAddress={setAddress}
				addressText={addressText}
				setAddressText={setAddressText}
				note={note}
				setNote={setNote}
				rateReview={rateReview}
				setRateReview={setRateReview}
				reviewCount={reviewCount}
				setReviewCount={setReviewCount}
				displayName={displayName}
				setDisplayName={setDisplayName}
				displayAddress={displayAddress}
				setDisplayAddress={setDisplayAddress}
				selectedPartnerEmail={selectedPartnerEmail}
				setSelectedPartnerEmail={setSelectedPartnerEmail}
				selectedPartnerId={selectedPartnerId}
				setSelectedPartnerId={setSelectedPartnerId}
				isAddToExistingPartner={isAddToExistingPartner}
				setIsAddToExistingPartner={setIsAddToExistingPartner}
				stationCom={stationCom}
				setStationCom={setStationCom}
				minimumPayout={minimumPayout}
				setMinimumPayout={setMinimumPayout}
				pubRate={pubRate}
				setPubRate={setPubRate}
				countryRatesRows={countryRatesRows}
				lat={lat}
				setLat={setLat}
				long={long}
				setLong={setLong}
				locationId={locationId}
				setLocationId={setLocationId}
				selectedLocation={selectedLocation}
				setSelectedLocation={setSelectedLocation}
				destinationSelectRef={destinationSelectRef}
			/>
		</DialogWrapMedium>
	);
}

export function InputPartnerAdmin(props: {
	name: string;
	setName: (val: string) => void;
	email: string;
	setEmail: (val: string) => void;
	phone: string;
	setPhone: (val: string) => void;
	pass: string;
	setPass: (val: string) => void;
	selectedCountryCode: string;
	setSelectedCountryCode: (val: string) => void;
	address: string;
	setAddress: (val: string) => void;
	addressText: string;
	setAddressText: (val: string) => void;
	note: string;
	setNote: (val: string) => void;
	rateReview: string;
	setRateReview: (val: string) => void;
	reviewCount: string;
	setReviewCount: (val: string) => void;
	displayName: string;
	setDisplayName: (val: string) => void;
	displayAddress: string;
	setDisplayAddress: (val: string) => void;
	update?: boolean;
	selectedPartnerEmail: string;
	setSelectedPartnerEmail: (val: string) => void;
	selectedPartnerId: string;
	setSelectedPartnerId: (val: string) => void;
	isAddToExistingPartner: boolean;
	setIsAddToExistingPartner: (val: boolean) => void;
	stationCom?: string;
	setStationCom?: (val: string) => void;
	minimumPayout?: string;
	setMinimumPayout?: (val: string) => void;
	pubRate?: string;
	setPubRate?: (val: string) => void;
	countryRatesRows?: any[];
	lat?: string;
	setLat?: (val: string) => void;
	long?: string;
	setLong?: (val: string) => void;
	locationId?: string;
	setLocationId?: (val: string) => void;
	selectedLocation?: any | null;
	setSelectedLocation?: (val: any | null) => void;
	destinationSelectRef?: React.RefObject<PartnerDestinationSelectHandle | null> | React.MutableRefObject<PartnerDestinationSelectHandle | null>;
}) {
	const pricingPreview = useMemo(
		() =>
			buildPartnerPricingPreview({
				countryRatesRows: props.countryRatesRows,
				address: props.address,
				addressText: props.addressText,
				selectedCountryCode: props.selectedCountryCode,
				destinationCountry: props.selectedLocation?.country,
				manualStationCom: props.stationCom,
				manualMinimumPayout: props.minimumPayout,
			}),
		[
			props.address,
			props.addressText,
			props.countryRatesRows,
			props.minimumPayout,
			props.selectedCountryCode,
			props.selectedLocation?.country,
			props.stationCom,
		]
	);

	const formatNum = (v: number | null) =>
		v === null
			? "—"
			: new Intl.NumberFormat("en-US", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 8,
			  }).format(v);
	const hasStationComOverride = Number(props.stationCom) > 0;
	const hasMinimumPayoutOverride = Number(props.minimumPayout) > 0;
	const moneySuffix = pricingPreview.detectedCurrency?.code ? ` ${pricingPreview.detectedCurrency.code}` : "";
	const stationComAppliedText =
		pricingPreview.appliedStationCom !== null
			? `${hasStationComOverride ? "Override" : "Country Rates"}: ${formatNum(
				pricingPreview.appliedStationCom
			)}${moneySuffix}`
			: null;
	const minPayoutAppliedText =
		pricingPreview.appliedMinimumPayoutLocal !== null
			? hasMinimumPayoutOverride &&
				pricingPreview.appliedMinimumPayoutUsd &&
				pricingPreview.detectedCurrency?.code &&
				pricingPreview.detectedCurrency.code !== "USD"
				? `${formatNum(pricingPreview.appliedMinimumPayoutUsd)} USD -> ${formatNum(
					pricingPreview.appliedMinimumPayoutLocal
				)} ${pricingPreview.detectedCurrency.code}`
				: `${hasMinimumPayoutOverride ? "Thực tế" : "Country Rates"}: ${formatNum(
					pricingPreview.appliedMinimumPayoutLocal
				)}${moneySuffix || " USD"}`
			: null;
	const appliedPillStyle: React.CSSProperties = {
		display: "inline-flex",
		alignItems: "center",
		padding: "4px 8px",
		borderRadius: 999,
		background: "#EFF6FF",
		border: "1px solid #BFDBFE",
		color: "#1D4ED8",
		fontSize: 10,
		fontWeight: 600,
		whiteSpace: "nowrap",
	};

	const sectionStyle: React.CSSProperties = {
		background: "#F9FAFB",
		border: "1px solid #E5E7EB",
		borderRadius: 10,
		padding: "14px 16px",
		marginBottom: 16,
	};
	const sectionTitleStyle: React.CSSProperties = {
		fontWeight: 700,
		fontSize: 14,
		marginBottom: 12,
		display: "flex",
		alignItems: "center",
		gap: 6,
		color: "#1F2937",
	};
	const labelStyle: React.CSSProperties = {
		fontWeight: 600,
		fontSize: 12,
		color: "#374151",
		marginBottom: 3,
		textTransform: "uppercase" as const,
		letterSpacing: "0.03em",
	};
	const gridRow: React.CSSProperties = {
		display: "grid",
		gridTemplateColumns: "1fr 1fr",
		gap: 12,
		marginBottom: 10,
	};

	return (
		<div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
			{/* ═══ Section 1: Thông tin cơ bản ═══ */}
			<div style={sectionStyle}>
				<div style={sectionTitleStyle}>👤 Thông tin cơ bản</div>

				<div style={labelStyle}>Tên Station</div>
				<FomrmLoginInput
					placeholder="Nhập tên station"
					value={props.name}
					onChange={(e) => props.setName(e.target.value)}
				/>

				<div style={{ marginTop: 10 }}>
					<CheckboxContainer>
						<CheckboxInput
							type="checkbox"
							checked={props.isAddToExistingPartner}
							onChange={(e) => props.setIsAddToExistingPartner(e.target.checked)}
						/>
						<CheckboxLabel>Thêm vào chi nhánh đã có?</CheckboxLabel>
					</CheckboxContainer>
				</div>

				{props.isAddToExistingPartner ? (
					<>
						<div style={labelStyle}>Chọn Chi nhánh</div>
						<PartnerSelectWithEmail
							selectedPartnerId={props.selectedPartnerId}
							setSelectedPartnerEmail={props.setSelectedPartnerEmail}
							setSelectedPartnerId={props.setSelectedPartnerId}
						/>
					</>
				) : (
					<>
						<div style={labelStyle}>Email</div>
						<FomrmLoginInput
							placeholder="email@example.com"
							value={props.email}
							onChange={(e) => props.setEmail(e.target.value)}
						/>
					</>
				)}

				<div style={gridRow}>
					<div>
						<div style={labelStyle}>Mật khẩu</div>
						<FomrmLoginInput
							placeholder="Nhập mật khẩu"
							type="password"
							value={props.pass}
							onChange={(e) => props.setPass(e.target.value)}
						/>
					</div>
					<div>
						<div style={labelStyle}>Số điện thoại</div>
						<OrderInputWrap style={{ marginBottom: 0 }}>
							<OrderInputPhoneNumberWrap>
								<FomrmLoginInputPhoneNumberInner>
									<CustomDropdown
										selectedCountryCode={props.selectedCountryCode}
										setSelectedCountryCode={props.setSelectedCountryCode}
									/>
									<FomrmLoginInputPhone
										placeholder="Nhập số điện thoại"
										type="tel"
										inputMode="numeric"
										value={props.phone}
										onChange={(e) => {
											const v = e.target.value.replace(/[^0-9]/g, "");
											props.setPhone(v);
										}}
									/>
								</FomrmLoginInputPhoneNumberInner>
							</OrderInputPhoneNumberWrap>
						</OrderInputWrap>
					</div>
				</div>
			</div>

			{/* ═══ Section 2: Địa chỉ ═══ */}
			<div style={sectionStyle}>
				<div style={sectionTitleStyle}>📍 Địa chỉ</div>
				<div style={{ marginBottom: 10 }}>
					<div style={labelStyle}>Location (Country / City)</div>
					<PartnerDestinationSelect
						ref={props.destinationSelectRef as React.Ref<PartnerDestinationSelectHandle>}
						mode="worldLibraryAndCreate"
						destinationId={props.locationId ?? ""}
						setDestinationId={(id) => props.setLocationId?.(id)}
						setSelectedLocation={(loc) => props.setSelectedLocation?.(loc)}
					/>
				</div>
				<div style={gridRow}>
					<div>
						<div style={labelStyle}>Vĩ độ (Lat)</div>
						<FomrmLoginInput
							placeholder="Latitude"
							value={props.lat ?? ""}
							onChange={(e) => props.setLat?.(e.target.value)}
						/>
					</div>
					<div>
						<div style={labelStyle}>Kinh độ (Long)</div>
						<FomrmLoginInput
							placeholder="Longitude"
							value={props.long ?? ""}
							onChange={(e) => props.setLong?.(e.target.value)}
						/>
					</div>
				</div>
				<div style={gridRow}>
					<div>
						<div style={labelStyle}>Google Maps link</div>
						<FomrmLoginInput
							placeholder="VD: https://maps.app.goo.gl/... hoặc maps.google.com/?q=..."
							value={props.address}
							onChange={(e) => props.setAddress(e.target.value)}
						/>
					</div>
					<div>
						<div style={labelStyle}>Address Text</div>
						<FomrmLoginInput
							placeholder="Mô tả địa chỉ (hiển thị/ghi chú)"
							value={props.addressText}
							onChange={(e) => props.setAddressText(e.target.value)}
						/>
					</div>
				</div>
				<div style={gridRow}>
					<div>
						<div style={labelStyle}>Display Name</div>
						<FomrmLoginInput
							placeholder="Tên hiển thị"
							value={props.displayName}
							onChange={(e) => props.setDisplayName(e.target.value)}
						/>
					</div>
					<div>
						<div style={labelStyle}>Display Address</div>
						<FomrmLoginInput
							placeholder="Địa chỉ hiển thị"
							value={props.displayAddress}
							onChange={(e) => props.setDisplayAddress(e.target.value)}
						/>
					</div>
				</div>
			</div>

			{/* ═══ Section 3: Đánh giá & Ghi chú ═══ */}
			<div style={sectionStyle}>
				<div style={sectionTitleStyle}>⭐ Đánh giá & Ghi chú</div>
				<div style={gridRow}>
					<div>
						<div style={labelStyle}>Rate Review</div>
						<FomrmLoginInput
							placeholder="VD: 4.5"
							type="text"
							inputMode="decimal"
							value={props.rateReview}
							onChange={(e) => {
								const v = e.target.value.replace(/[^0-9.]/g, "");
								props.setRateReview(v);
							}}
						/>
					</div>
					<div>
						<div style={labelStyle}>Review Count</div>
						<FomrmLoginInput
							placeholder="VD: 120"
							type="text"
							inputMode="numeric"
							value={props.reviewCount}
							onChange={(e) => {
								const v = e.target.value.replace(/[^0-9]/g, "");
								props.setReviewCount(v);
							}}
						/>
					</div>
				</div>
				<div style={labelStyle}>Ghi chú</div>
				<FomrmLoginInput
					placeholder="Ghi chú nội bộ"
					value={props.note}
					onChange={(e) => props.setNote(e.target.value)}
				/>
			</div>

			{/* ═══ Section 4: Cấu hình tài chính ═══ */}
			<div style={{ ...sectionStyle, background: "#F0F9FF", border: "1px solid #BAE6FD" }}>
				<div style={{ ...sectionTitleStyle, color: "#0369A1" }}>💰 Cấu hình tài chính</div>

				<div style={{ color: "#6B7280", fontSize: 11, marginBottom: 12, fontStyle: "italic" }}>
					Để trống = dùng mặc định từ Country Rates.
				</div>

				{/* Detected country + currency badge */}
				<div style={{ display: "flex", gap: 10, marginBottom: 12, flexWrap: "wrap" }}>
					{pricingPreview.detectedCountry ? (
						<div
							style={{
								display: "inline-flex",
								alignItems: "center",
								gap: 6,
								background: "#ECFDF5",
								border: "1px solid #A7F3D0",
								borderRadius: 8,
								padding: "5px 12px",
								fontSize: 12,
								color: "#065F46",
							}}>
							🌍 <strong>{pricingPreview.detectedCountry}</strong>
						</div>
					) : (
						<div
							style={{
								display: "inline-flex",
								alignItems: "center",
								gap: 6,
								background: "#FEF3C7",
								border: "1px solid #FDE68A",
								borderRadius: 8,
								padding: "5px 12px",
								fontSize: 11,
								color: "#92400E",
							}}>
							⚠️ Chưa nhận diện quốc gia
						</div>
					)}
					{pricingPreview.detectedCurrency ? (
						<div
							style={{
								display: "inline-flex",
								alignItems: "center",
								gap: 6,
								background: "#EDE9FE",
								border: "1px solid #C4B5FD",
								borderRadius: 8,
								padding: "5px 12px",
								fontSize: 12,
								color: "#5B21B6",
							}}>
							💱 <strong>{pricingPreview.detectedCurrency.code}</strong>
							{pricingPreview.detectedCurrency.name && (
								<span style={{ fontWeight: 400, color: "#7C3AED" }}>
									({pricingPreview.detectedCurrency.name})
								</span>
							)}
						</div>
					) : null}
				</div>

				{/* Row 1: EST STT Com | STT Com */}
				<div style={gridRow}>
					<div>
						<div style={labelStyle}>
							<span style={{ color: "#065F46" }}>EST STT Com</span>
							<span style={{ fontWeight: 400, color: "#9CA3AF", fontSize: 10, marginLeft: 4 }}>
								(ước tính)
							</span>
						</div>
						<div
							style={{
								background: pricingPreview.detectedCountry ? "#D1FAE5" : "#F3F4F6",
								border: `1px solid ${pricingPreview.detectedCountry ? "#6EE7B7" : "#E5E7EB"}`,
								borderRadius: 6,
								padding: "9px 10px",
								fontSize: 15,
								fontWeight: 700,
								color: pricingPreview.detectedCountry ? "#047857" : "#9CA3AF",
								minHeight: 40,
								display: "flex",
								alignItems: "center",
							}}>
							{formatNum(pricingPreview.estSttCom)}
						</div>
					</div>
					<div>
						<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, marginBottom: 3 }}>
							<div style={labelStyle}>
								<span style={{ color: "#1E40AF" }}>STT Com</span>
								<span style={{ fontWeight: 400, color: "#9CA3AF", fontSize: 10, marginLeft: 4 }}>
									(nhập tay)
								</span>
							</div>
							{stationComAppliedText ? <div style={appliedPillStyle}>{stationComAppliedText}</div> : null}
						</div>
						<FomrmLoginInput
							placeholder={
								pricingPreview.estSttCom
									? `Mặc định: ${formatNum(pricingPreview.estSttCom)}`
									: "Nhập giá trị"
							}
							type="text"
							inputMode="decimal"
							value={props.stationCom ?? ""}
							onChange={(e) => {
								const v = e.target.value.replace(/[^0-9.]/g, "");
								props.setStationCom?.(v);
							}}
						/>
					</div>
				</div>

				{/* Row 2: Est Min Payout | Min Payout */}
				<div style={gridRow}>
					<div>
						<div style={labelStyle}>
							<span style={{ color: "#065F46" }}>Est Min Payout</span>
							<span style={{ fontWeight: 400, color: "#9CA3AF", fontSize: 10, marginLeft: 4 }}>
								(ước tính)
							</span>
						</div>
						<div
							style={{
								background: pricingPreview.detectedCountry ? "#D1FAE5" : "#F3F4F6",
								border: `1px solid ${pricingPreview.detectedCountry ? "#6EE7B7" : "#E5E7EB"}`,
								borderRadius: 6,
								padding: "9px 10px",
								fontSize: 15,
								fontWeight: 700,
								color: pricingPreview.detectedCountry ? "#047857" : "#9CA3AF",
								minHeight: 40,
								display: "flex",
								alignItems: "center",
							}}>
							{formatNum(pricingPreview.estMinPayout)}
						</div>
					</div>
					<div>
						<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, marginBottom: 3 }}>
							<div style={labelStyle}>
								<span style={{ color: "#1E40AF" }}>Min Payout</span>
								<span style={{ fontWeight: 400, color: "#9CA3AF", fontSize: 10, marginLeft: 4 }}>
									(nhập tay)
								</span>
							</div>
							{minPayoutAppliedText ? <div style={appliedPillStyle}>{minPayoutAppliedText}</div> : null}
						</div>
						<FomrmLoginInput
							placeholder={
								pricingPreview.estMinPayout
									? `Mặc định: ${formatNum(pricingPreview.estMinPayout)}`
									: "Nhập giá trị"
							}
							type="text"
							inputMode="decimal"
							value={props.minimumPayout ?? ""}
							onChange={(e) => {
								const v = e.target.value.replace(/[^0-9.]/g, "");
								props.setMinimumPayout?.(v);
							}}
						/>
						<div style={{ fontSize: 10, color: "#6B7280", marginTop: 4 }}>
							Nhập tay theo USD, hệ thống sẽ tự quy đổi ra local currency đang áp dụng.
						</div>
					</div>
				</div>

				{/* Row 3: Public Rate */}
				<div style={gridRow}>
					<div>
						<div style={labelStyle}>
							<span style={{ color: "#1E40AF" }}>Public Rate</span>
							<span style={{ fontWeight: 400, color: "#9CA3AF", fontSize: 10, marginLeft: 4 }}>
								(nhập tay)
							</span>
						</div>
						<FomrmLoginInput
							placeholder="VD: 4.75"
							type="text"
							inputMode="decimal"
							value={props.pubRate ?? ""}
							onChange={(e) => {
								const v = e.target.value.replace(/[^0-9.]/g, "");
								props.setPubRate?.(v);
							}}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

